import { LegendItemModel } from "models/LegendItem";

export function getValidResourcePlays(
  checkedItems: LegendItemModel[]
): LegendItemModel[] {
  return checkedItems.filter(
    (item) =>
      item.property === "Header.ResourcePlay" &&
      !item.isNotEqual &&
      !item.isOthersRollup &&
      !isMinSizeBin(item.value)
  );
}

export function isMinSizeBin(value: unknown): boolean {
  return (
    typeof value === "string" &&
    value.includes("Less Than") &&
    value.includes("Sample Size")
  );
}
